// @ts-check
import useConfiguredSWRV from 'app/useConfiguredSwrv';
import { apis } from 'api/client';
import useCacheManager from 'use/cacheManager';
import { getUID } from 'helpers';

/**
 * @type {{
 *  name: string
 *  uuid: string
 * }}
 */
const metadata = {
    name: 'Manufacturers',
    uuid: getUID(),
};

/**
 * Setup cache/refresh for Shipping Methods
 * @returns
 */
export default function useManufacturers(config = {}) {
    const fetcher = async () => {
        const resp = await apis.Manufacturers.listManufacturersProductTypeMap();
        return resp?.body || {};
    };

    const { data: manufacturers, error, isValidating, mutate } = useConfiguredSWRV(metadata.uuid, fetcher, config);

    if (!manufacturers.value) {
        manufacturers.value = {};
    }

    useCacheManager(mutate, metadata);

    return {
        /**
         * @type {import('@vue/composition-api').Ref<Manufacturers[]>}
         */
        manufacturers,
        error,
        isValidating,
        mutate,
        metadata,
    };
}
